export default __webpack_public_path__ + "static/hubble-826188598d10d577a91bc0932b3520eb.png";